import { pgTable, uuid, text, integer, timestamp, index, uniqueIndex } from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// PI.5: Staff Performance Goals
// ---------------------------------------------------------------------------
// Configurable per-staff per-period targets for leaderboard tracking.
// "Set goal: 50 tasks/month for all staff" → dashboard shows achieved %.

const tz = { withTimezone: true } as const;

export const staffGoals = pgTable("staff_goals", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  staffUserId: uuid("staff_user_id").notNull(),
  period: text("period").notNull(), // "2026-03" (year-month)
  metricType: text("metric_type").notNull(), // "tasks_completed" | "deals_won" | "revenue_cents" | "bookings_delivered" | "response_time_hours"
  targetValue: integer("target_value").notNull(),
  actualValue: integer("actual_value").notNull().default(0),
  achievedPercent: integer("achieved_percent").notNull().default(0),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_staff_goals_tenant_staff").on(table.tenantId, table.staffUserId),
  index("idx_staff_goals_period").on(table.tenantId, table.period),
  // Prevent duplicate goals for same staff + period + metric
  uniqueIndex("uq_staff_goals_tenant_staff_period_metric").on(
    table.tenantId, table.staffUserId, table.period, table.metricType,
  ),
]);
